import {createActionGroup, emptyProps} from "@ngrx/store";

export const NotificationActions = createActionGroup({
  source: "Notification",
  events: {
    acceptAllEmails: emptyProps(),
  },
});
